
import { apply, load, setAlias } from '../engine'
import { Attr } from "../plugins/official/dom/attributes/attr"
import { Bind } from "../plugins/official/dom/attributes/bind"
import { Class } from "../plugins/official/dom/attributes/class"
import { On } from "../plugins/official/dom/attributes/on"
import { Ref } from "../plugins/official/dom/attributes/ref"
import { Show } from "../plugins/official/dom/attributes/show"
import { Text } from "../plugins/official/dom/attributes/text"


load(
    Attr,
    Bind,
    Class,
    On,
    Ref,
    Show,
    Text,
)

apply()
export { apply, load, setAlias }
